var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.userData.dataVisualFeature == 1
    ? _c("div", [
        _vm._m(0),
        _c("div", { staticClass: "tab-content" }, [
          _c(
            "div",
            {
              staticClass: "filter pull-right",
              class: _vm.showFilterPop ? "open" : ""
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  staticStyle: { "text-transform": "none" },
                  attrs: { href: "#", role: "button" },
                  on: {
                    click: function($event) {
                      _vm.showFilterPop = true
                    }
                  }
                },
                [_vm._v("Filter")]
              ),
              _c(
                "a",
                { attrs: { href: "#" }, on: { click: _vm.printDownload } },
                [_vm._v("Export")]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFilterPop,
                      expression: "showFilterPop"
                    }
                  ],
                  staticClass: "filter-box dropdown-menu",
                  staticStyle: { "text-transform": "none", color: "#782B55" }
                },
                [
                  _c(
                    "h5",
                    {
                      staticStyle: {
                        color: "#000",
                        "font-size": "20px",
                        "border-bottom": "1px solid",
                        "padding-bottom": "18px"
                      }
                    },
                    [
                      _vm._v("Filters\n          "),
                      _c(
                        "a",
                        {
                          staticStyle: { float: "right", "margin-top": "-8px" },
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function($event) {
                              _vm.showFilterPop = false
                            }
                          }
                        },
                        [_vm._v("X")]
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showPersonalDetailsFilter
                          ? "- Date Range"
                          : "+ Date Range"
                      )
                    },
                    on: { click: _vm.togglePersonalFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showPersonalDetailsFilter,
                          expression: "showPersonalDetailsFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c("label", [_vm._v("From Date")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.startDate,
                            expression: "filters.startDate"
                          }
                        ],
                        attrs: {
                          type: "date",
                          name: "startDate",
                          placeholder: "From Date"
                        },
                        domProps: { value: _vm.filters.startDate },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.filters,
                              "startDate",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c("label", [_vm._v("To Date")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.endDate,
                            expression: "filters.endDate"
                          }
                        ],
                        attrs: {
                          type: "date",
                          name: "endDate",
                          placeholder: "To Date"
                        },
                        domProps: { value: _vm.filters.endDate },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.filters,
                              "endDate",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showCampaignFilter
                          ? "- Campaign Name"
                          : "+ Campaign Name"
                      )
                    },
                    on: { click: _vm.toggleCampaignFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCampaignFilter,
                          expression: "showCampaignFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.campaignId,
                              expression: "filters.campaignId"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "campaignId" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "campaignId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.campaignList, function(campaign) {
                            return _c(
                              "option",
                              {
                                key: campaign.id,
                                domProps: { value: campaign.id }
                              },
                              [_vm._v(_vm._s(campaign.name))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showRetailerFilter
                          ? "- Retailer Name"
                          : "+ Retailer Name"
                      )
                    },
                    on: { click: _vm.toggleRetailerFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showRetailerFilter,
                          expression: "showRetailerFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.storeId,
                              expression: "filters.storeId"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "storeId" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "storeId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.retailerList, function(retailer) {
                            return _c(
                              "option",
                              {
                                key: retailer.id,
                                domProps: { value: retailer.id }
                              },
                              [_vm._v(_vm._s(retailer.name))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showProductFilter
                          ? "- Product Name"
                          : "+ Product Name"
                      )
                    },
                    on: { click: _vm.toggleProductFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProductFilter,
                          expression: "showProductFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.productId,
                              expression: "filters.productId"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "productId" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "productId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.productList, function(product) {
                            return _c(
                              "option",
                              {
                                key: product.id,
                                domProps: { value: product.id }
                              },
                              [_vm._v(_vm._s(product.name))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c(
                    "h5",
                    {
                      staticStyle: {
                        color: "#000",
                        "margin-top": "30px",
                        "padding-top": "25px",
                        "font-size": "17px",
                        "border-top": "1px solid",
                        "padding-bottom": "10px"
                      }
                    },
                    [_vm._v("For Consumer Insights")]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showGenderFilter ? "- Gender" : "+ Gender"
                      )
                    },
                    on: { click: _vm.toggleGenderFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showGenderFilter,
                          expression: "showGenderFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.gender,
                              expression: "filters.gender"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "gender" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "gender",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _c("option", { attrs: { value: "male" } }, [
                            _vm._v("Male")
                          ]),
                          _c("option", { attrs: { value: "female" } }, [
                            _vm._v("Female")
                          ]),
                          _c("option", { attrs: { value: "other" } }, [
                            _vm._v("Other")
                          ])
                        ]
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showEthnicFilter ? "- Ethnic" : "+ Ethnic"
                      )
                    },
                    on: { click: _vm.toggleEthnicFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showEthnicFilter,
                          expression: "showEthnicFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.ethnicBackground,
                              expression: "filters.ethnicBackground"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "ethnicBackground" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "ethnicBackground",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.ethnicBackground, function(ethnic) {
                            return _c(
                              "option",
                              {
                                key: ethnic.ethnic_background,
                                domProps: { value: ethnic.ethnic_background }
                              },
                              [_vm._v(_vm._s(ethnic.ethnic_background))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showPetsFilter ? "- Pets" : "+ Pets"
                      )
                    },
                    on: { click: _vm.togglePetsFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showPetsFilter,
                          expression: "showPetsFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.pets,
                              expression: "filters.pets"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "pets" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "pets",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.petsList, function(pets) {
                            return _c(
                              "option",
                              {
                                key: pets.pets,
                                domProps: { value: pets.pets }
                              },
                              [_vm._v(_vm._s(pets.pets))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showCosmeticFilter ? "- Cosmetics" : "+ Cosmetics"
                      )
                    },
                    on: { click: _vm.toggleCosmeticFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCosmeticFilter,
                          expression: "showCosmeticFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.cosmetics,
                              expression: "filters.cosmetics"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "cosmetics" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "cosmetics",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.cosmeticsList, function(cosmetics) {
                            return _c(
                              "option",
                              {
                                key: cosmetics.cosmetics,
                                domProps: { value: cosmetics.cosmetics }
                              },
                              [_vm._v(_vm._s(cosmetics.cosmetics))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.showChildrenFilter ? "- Children" : "+ Children"
                      )
                    },
                    on: { click: _vm.toggleChildrenFilters }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showChildrenFilter,
                          expression: "showChildrenFilter"
                        }
                      ],
                      staticClass: "form-card"
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters.children,
                              expression: "filters.children"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { name: "children" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filters,
                                "children",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select")
                          ]),
                          _vm._l(_vm.childrenList, function(children) {
                            return _c(
                              "option",
                              {
                                key: children.children,
                                domProps: { value: children.children }
                              },
                              [_vm._v(_vm._s(children.children))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "apply-btn",
                      attrs: { href: "#" },
                      on: { click: _vm.getSucessMetrics }
                    },
                    [_vm._v("Apply")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "apply-btn",
                      staticStyle: { "margin-left": "20px !important" },
                      attrs: { href: "/brand/data-analysis" }
                    },
                    [_vm._v("Reset")]
                  )
                ]
              )
            ]
          ),
          _c("div", { staticStyle: { width: "100%", float: "left" } }),
          _c(
            "div",
            {
              staticClass: "tab-pane fade in active",
              attrs: { role: "tabpanel", id: "CampaignInsights" }
            },
            [
              _c("h3", { staticStyle: { clear: "both" } }, [
                _vm._v("Campaign Summary")
              ]),
              _c("campaign-summary", {
                attrs: {
                  brandId: _vm.brandId,
                  totalSelfies: _vm.totalSelfies,
                  totalPhotos: _vm.totalPhotos,
                  totalResponses: _vm.totalResponses,
                  SalesConversionRate: _vm.SalesConversionRate,
                  purchaseIntentSummaryTotal: _vm.purchaseIntentSummaryTotal,
                  shopIntentSummaryYes: _vm.shopIntentSummaryYes,
                  shopIntentSummaryTotal: _vm.shopIntentSummaryTotal,
                  purchaseIntentSummaryYes: _vm.purchaseIntentSummaryYes,
                  activitiesCompletedNumber: _vm.activitiesCompletedNumber,
                  upsellRatio: _vm.upsellRatio,
                  activitiesCompletedPercentage:
                    _vm.activitiesCompletedPercentage,
                  activitiesWithIssuesNumber: _vm.activitiesWithIssuesNumber,
                  activitiesWithNotesPercentage:
                    _vm.activitiesWithNotesPercentage,
                  repeatLocations: _vm.repeatLocations,
                  byMeCreditConsumed: _vm.byMeCreditConsumed,
                  AverageLeadResponseTime: _vm.AverageLeadResponseTime,
                  FastestLeadResponseTime: _vm.FastestLeadResponseTime,
                  tripsFrequency: _vm.tripsFrequency,
                  basketSize: _vm.basketSize,
                  SalesConversionRateNumber: _vm.SalesConversionRateNumber,
                  retentionRateNumber: _vm.retentionRateNumber,
                  upsellRatioNumber: _vm.upsellRatioNumber,
                  activitiesWithNotesNumber: _vm.activitiesWithNotesNumber,
                  activitiesWithIssuesPercentage:
                    _vm.activitiesWithIssuesPercentage
                }
              }),
              _c("h3", { staticStyle: { clear: "both" } }, [
                _vm._v("Total Audience Active Time")
              ]),
              _c("data-engagement-time", {
                attrs: {
                  brandId: _vm.brandId,
                  totalDealDropTime: _vm.totalDealDropTime,
                  totalSelfies: _vm.totalSelfies,
                  homeTaskMediaTime: _vm.homeTaskMediaTime,
                  surveyAvgEngagementMinutes: _vm.surveyAvgEngagementMinutes,
                  surveyTotalTimeMinutes: _vm.surveyTotalTimeMinutes,
                  avgHomeTaskTime: _vm.avgHomeTaskTime,
                  productAvgEngagementMinutes: _vm.productAvgEngagementMinutes,
                  totalHomeTaskTime: _vm.totalHomeTaskTime,
                  totalTimeMinutes: _vm.totalTimeMinutes,
                  avgEngagementMinutes: _vm.avgEngagementMinutes,
                  productTotalTimeMinutes: _vm.productTotalTimeMinutes,
                  fastestActivityMinutes: _vm.fastestActivityMinutes,
                  slowestActivityminutes: _vm.slowestActivityminutes
                }
              }),
              _c("h3", { staticStyle: { clear: "both" } }, [
                _vm._v("Total Audience Interactions")
              ]),
              _c("data-touchpoints", {
                attrs: {
                  brandId: _vm.brandId,
                  activitiesWithNotesNumber: _vm.activitiesWithNotesNumber,
                  activitiesWithIssuesNumber: _vm.activitiesWithIssuesNumber,
                  totalPhotos: _vm.totalPhotos,
                  totalResponses: _vm.totalResponses,
                  acceptedCountTouchPoints: _vm.acceptedCountTouchPoints,
                  impression: _vm.impression,
                  touchPointStatsGeoNotAprove: _vm.touchPointStatsGeoNotAprove,
                  totalDealDropTouchPoints: _vm.totalDealDropTouchPoints,
                  touchPointAvgNonGeo: _vm.touchPointAvgNonGeo,
                  touchPointTotalGeo: _vm.touchPointTotalGeo,
                  touchPointStatsDealDrop: _vm.touchPointStatsDealDrop,
                  touchPointStatsNonGeo: _vm.touchPointStatsNonGeo,
                  touchPointAvgGeo: _vm.touchPointAvgGeo
                }
              }),
              _c("h3", [_vm._v("Social Selfies")]),
              _c("user-social-selfies-data", {
                attrs: { brandId: _vm.brandId }
              }),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-7" }, [
                  _c(
                    "div",
                    { staticClass: "coast-box" },
                    [
                      _c("h3", [_vm._v("Coast to Coast activities")]),
                      _c("coast-to-coast-activities", {
                        attrs: {
                          brandId: _vm.brandId,
                          coastToCoastData: _vm.coastToCoastData
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "col-md-5" }, [
                  _c(
                    "div",
                    { staticClass: "coast-box" },
                    [
                      _c("h3", [_vm._v("Activities with Issues summary")]),
                      _c("activities-with-issues-summary", {
                        attrs: {
                          brandId: _vm.brandId,
                          activitiesWithIssuesSummaryData:
                            _vm.activitiesWithIssuesSummaryData
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "tab-pane fade in",
              attrs: { role: "tabpanel", id: "ConsumerInsights" }
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedQuestionId,
                      expression: "selectedQuestionId"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "max-width": "58.333%" },
                  attrs: { name: "questionId" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedQuestionId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.setSelectedQuestion
                    ]
                  }
                },
                _vm._l(_vm.questionsList, function(question) {
                  return _c(
                    "option",
                    { key: question.id, domProps: { value: question.id } },
                    [_vm._v(_vm._s(question.question))]
                  )
                }),
                0
              ),
              _vm.selectedQuestionType != "TEXT"
                ? _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-top": "30px" }
                    },
                    [
                      _c("div", { staticClass: "col-md-7" }, [
                        _c(
                          "div",
                          { staticClass: "coast-box" },
                          [
                            _c("h3", [
                              _vm._v(_vm._s(_vm.selectedQuesetion.question))
                            ]),
                            _c("insight-question", {
                              attrs: {
                                brandId: _vm.brandId,
                                insightData: _vm.insightData
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "col-md-5" }, [
                        _c(
                          "div",
                          { staticClass: "coast-box" },
                          [
                            _c("h3", [
                              _vm._v(_vm._s(_vm.selectedQuesetion.question))
                            ]),
                            _c("insight-overall", {
                              attrs: {
                                brandId: _vm.brandId,
                                insightOverallData: _vm.insightOverallData
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-top": "30px" }
                    },
                    [
                      _c("table", { staticClass: "table" }, [
                        _vm._m(1),
                        _c(
                          "tbody",
                          _vm._l(_vm.insightData, function(userAnswer, index) {
                            return _c("tr", { key: index }, [
                              _c("th", { attrs: { scope: "row" } }, [
                                _vm._v(_vm._s(index + 1))
                              ]),
                              _c("td", [_vm._v(_vm._s(userAnswer.textAnswer))]),
                              _c("td", [
                                _vm._v(_vm._s(userAnswer.totalResponse))
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    ]
                  )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "tab-pane fade in",
              staticStyle: {
                border: "2px solid #12db6d",
                width: "100%",
                padding: "25px",
                "margin-top": "30px",
                float: "left"
              },
              attrs: { role: "tabpanel", id: "BuyMeInsights" }
            },
            [
              _c("h3", { staticStyle: { "margin-top": "10px" } }, [
                _vm._v("Product Purchase Summary")
              ]),
              _c("product-purchase-summary", {
                attrs: {
                  brandId: _vm.brandId,
                  ProductPurchaseSummaryData: _vm.ProductPurchaseSummaryData
                }
              })
            ],
            1
          ),
          _vm._m(2)
        ])
      ])
    : _c("div", [
        _c("h2", { staticStyle: { "text-align": "center" } }, [
          _vm._v(
            "This feature is not available for you! Contact support to activate this feature"
          )
        ])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-tab" }, [
      _c("ul", { staticClass: "nav nav-tabs", attrs: { role: "tablist" } }, [
        _c("li", { staticClass: "active", attrs: { role: "presentation" } }, [
          _c(
            "a",
            {
              attrs: {
                href: "#CampaignInsights",
                "aria-controls": "pickl",
                role: "tab",
                "data-toggle": "tab"
              }
            },
            [_vm._v("Campaign Insights")]
          )
        ]),
        _c("li", { attrs: { role: "presentation" } }, [
          _c(
            "a",
            {
              attrs: {
                href: "#ConsumerInsights",
                "aria-controls": "pickl",
                role: "tab",
                "data-toggle": "tab"
              }
            },
            [_vm._v("Consumer Insights")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("#")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Answer")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Response Count")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "tab-pane fade in",
        attrs: { role: "tabpanel", id: "MediaInsights" }
      },
      [
        _c("div", { staticClass: "media_insights" }, [
          _c("img", { attrs: { src: "/img/lock_media.png" } }),
          _c(
            "h5",
            { staticStyle: { "font-size": "22px", "line-height": "32px" } },
            [
              _vm._v("Contact customer service to"),
              _c("br"),
              _vm._v(" launch a Go-Anywhere campaign")
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }